<template>
  <section class="module-product">
       <NavComponent></NavComponent>
    <div class="bg">
      <div class="container">
        <p class="container-title" @click="goRelationPage">线上+线下全场景赋能营与销双轮驱动品效结合</p>
      </div>
    </div>

    <div class="container">
        <div class="set-title">
            <img src="../assets/title_left.png" class="col-sm-3 set-title-left" alt="">
            <div class="col-sm-6 set-title-center" @click="goRelationPage">赋能企业全员 智能精准营销</div>
            <img src="../assets/title_right.png" class="col-sm-3 set-title-right" alt="">
        </div>

        <div class="row">
            <div class="col-12 col-md-6 ">
                <h6 class="set-pointer" @click="goRelationPage">商家赋能，持续迭代</h6>
                <p>B2B2C模式，toB全面赋能。通过移动互联网/短视频/AI技术，赋能企业转型线上，加速业务线上化和电商化。通过线上开店+CRM+量子大学+流量赋能，助力商家布局未来，打造私域流量生态营销闭环，让“商家全员”完全掌控营销过程，数据营销、优化迭代轻松搞定！</p>
                <p>量子大学-通过“百师计划”、线上/面授、公开课/封闭辅导，培育短视频达人/导师，助力成长型企业把握短视频行业风口。</p>
            </div>
            <div class="pic col-6 d-none d-md-block">
                <img src="../assets/prp1.png" alt="审核">
            </div>
            <div class="col-6 pic d-none d-md-block">
                <img src="../assets/prp2f.png" alt="商家赋能">
            </div>
            <div class="col-12 col-md-6 ">
                <h6 class="set-pointer" @click="goRelationPage">精准营销，流量赋能</h6>
                <p>· 深耕微信和企业微信生态，与各大短视频平台连接，结合自媒体矩阵，为客户提供品效结合的OmniVideo全视频营销解决方案。</p>
                <p>· 通过店铺营销大本营+物料中心+推广中心+数据中心+CRM闭环营销，整套的流量运营方法论，私域流量+公域流量，切实帮助客户解决流量成本高居不下之痛。</p>
                <p>· 准确掌握每个销售线索，提供更实效的营销到店效果和在线电商转化。</p>
            </div>
        </div>
    </div>
     <FooterComponent></FooterComponent>
  </section>
</template>

<script>
import NavComponent from '@/components/header.vue'
import FooterComponent from '@/components/footer.vue'
import util from "../util/util.js";
export default {
    components: {
        NavComponent,
        FooterComponent
    },
    methods: {
        goRelationPage(){
            util.goContact();
        }
    }
}
</script>

<style lang="scss" scoped>
.module-product {
    .col-12.col-md-6{
        padding-right: 0px;
        padding-left: 0px;
    }
    @media screen and (min-width: 769px){
      & {
            .bg {
                padding-top: 160px;
                height: 350px;
                background: url("../assets/product_banner.png") center bottom no-repeat;
                background-size: 100% 100%;
                .container-title{
                    font-size: 28px;
                    font-weight: bold;
                    color:  #07C160;
                    cursor: pointer;
                    text-align: center;
                }
                
                img {
                    width: 100%;
                    max-width: 620px;
                }
            }

            .set-title{
                display: flex;
                height: 4rem;
                align-items: center;
                justify-content: center;
                .set-title-center{
                    height: 100%;
                    font-size: 1.6rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #07C160;
                    white-space: nowrap;
                    cursor: pointer;
                }
            }
      }
      
  }
//   .bg {
//     padding-top: 160px;
//     height: 350px;
//     background: url("../assets/product_banner.png") center bottom no-repeat;
//     background-size: 100% 100%;
//     .container-title{
//         font-size: 28px;
//         font-weight: bold;
//         color:  #07C160;
//         cursor: pointer;
//         text-align: center;
//     }
    
//     img {
//         width: 100%;
//         max-width: 620px;
//     }
//   }
  
  .title {
    padding: 5rem 0;
    text-align: center;

    img {
      width: 100%;
      max-width: 670px;
    }
  }
  .container{
      width: 100%;
    //   overflow: hidden;
  }
  

  .pic {
      text-align: center;
  }

  h6 {
      font-weight: bold;
      margin-bottom: 3rem;
      color: #333;
  }

  .row {
      align-items: center;
      .set-pointer{
        cursor: pointer;
        color: #07C160;
        font-size: 19px;
      }
  }

  @media screen and (max-width: 768px){
      & {
            .bg{
                width: 100%;
                height: 10rem;
                background: url("../assets/product_banner.png") center bottom no-repeat;
                background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            .container-title{
                color: #07C160;
                font-size: 1rem;
                font-weight: bold;
            }
            
            h6 {
                margin-top: 0.9rem;       
                margin-bottom: 1rem;       
            }
            .set-title{
                display: flex;
                height: 4rem;
                align-items: center;
                justify-content: center;
                .set-title-center{
                    height: 100%;
                    font-size: 1.1rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #07C160;
                    white-space: nowrap;
                    cursor: pointer;
                }
            }
            .row {
                padding: 0px 0.9rem;
                .set-pointer{
                    font-size: 0.9rem;
                }
            }
            p{
                font-size: 0.8rem;
            }
            .set-title{
                .set-title-left{
                    display: none;
                }
                .set-title-right{
                    display: none;
                }
            }
      }
      
  }

//   @media screen and (max-width: 576px) {
//       & {
//           .bg p {
//               font-size: 21px;
//           }
//           .row {
//               padding-right: 15px;
//               padding-left: 15px;
//           }
//           .set-title-center{
//             font-size: 1rem;
//          }
//       }
//   }

}
</style>